import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);
const routes = [
  {
    path: "/",
    redirect: "/annualMettingGames2023",
  },
  {
    path: "/321",
    redirect: "/321/consulting", //2023-02-24
    component: () => import("@/views/321/consulting.vue"),
    children: [
      {
        path: "consulting",
        component: () => import("@/views/321/consulting.vue"),
      },
    ],
  },
  {
    path: "/goMiniprogram",
    component: () => import("@/views/goMiniprogram.vue"),
  },
  {
    path: "/goScanFu",
    component: () => import("@/views/goScanFu.vue"),
  },
  {
    path: "/annualMettingGames2023",
    component: () => import("@/views/annualMettingGames2023.vue"),
  },
  {
    path: "/wxLive",
    component: () => import("@/views/wxLive/index.vue"),
    redirect: "/wxLive/wxLive",
    children: [
      {
        path: "wxLive",
        component: () => import("@/views/wxLive/wxLive.vue"),
      },
      {
        path: "bigscreen",
        component: () => import("@/views/wxLive/bigscreen.vue"),
      },
    ],
  },
  {
    path: "/housekeeper",
    component: () => import("@/views/housekeeper.vue"),
  },
  {
    path: "/page/:id",
    component: () => import("@/views/template/index.vue"),
  },
  {
    path: "/page-clue/:id",
    component: () => import("@/views/template/index.vue"),
  },
  {
    path: "/appdownload",
    component: () => import("@/views/appDownload/index.vue"),
    redirect: "/appdownload/derucci",
    children: [
      {
        path: "derucci",
        component: () => import("@/views/appDownload/derucci.vue"),
      },
      {
        path: "marketing",
        component: () => import("@/views/appDownload/marketing.vue"),
      },
    ],
  },
  {
    path: "/recruitPage",
    component: () => import("@/views/recruitPage.vue"),
  },
  {
    path: "/smsMarketing",
    component: () => import("@/views/smsMarketing.vue"),
  },
  {
    path: "/1212",
    component: () => import("@/views/1212/index.vue"),
    redirect: "/1212/signUp",
    children: [
      {
        path: "signUp",
        component: () => import("@/views/1212/signUp.vue"),
      },
      {
        path: "scanCode",
        component: () => import("@/views/1212/scanCode.vue"),
      },
    ],
  },
  {
    path: "/questionnaire/distributor-interview",
    component: () => import("@/views/questionnaire/distributor-interview.vue"),
  },
  {
    path: "/urlLink",
    component: () => import("@/views/urlLink.vue"),
  }
];
const router = new VueRouter({
  routes,
});

import { getStorage } from "@/utils/storage";
import store from "@/store";

router.beforeEach(async (to, from, next) => {
  if (!getStorage("tokenInfo")) {
    await store.dispatch("app/getToken");
  }

  next();
});

export default router;
